import React, { Fragment, useState, useEffect } from 'react'
import {
  array, bool, func, number,
} from 'prop-types'
import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import NavigationButton from './NavigationButton'

let Swiper
let SwiperSlide
let Pagination
let Navigation
let FreeMode
let Keyboard

function Carousel({
  slides,
  onActiveIndexChange,
  highlightActive = false,
  activeIndex,
  totalCount,
}) {
  const [isCoreLoaded, setIsCoreLoaded] = useState(false)
  const [isModuleLoaded, setIsModuleLoaded] = useState(false)

  function importCoreModules() {
    import('swiper/react').then((module) => {
      Swiper = module.Swiper
      SwiperSlide = module.SwiperSlide
      setIsCoreLoaded(true)
    })
  }

  function importAuxilaryModules() {
    import('swiper').then((module) => {
      Pagination = module.Pagination
      Navigation = module.Navigation
      FreeMode = module.FreeMode
      Keyboard = module.Keyboard
      setIsModuleLoaded(true)
    })
  }

  useEffect(() => {
    importCoreModules()
    importAuxilaryModules()
  }, [])

  if (isCoreLoaded && isModuleLoaded) {
    return (
      <Fragment>
        <Swiper
          modules={[Navigation, Pagination, FreeMode, Keyboard]}
          className={classnames(
            'cgt-carousel-new',
            slides.length === 1 && 'cgt-carousel-new--single-slide'
          )}
          slidesPerView="auto"
          slidesPerGroup={1}
          lazyPreloadPrevNext={1}
          lazyPreloaderClass="cgt-carousel-new__image-loader"
          pagination={{
            clickable: false,
            type: 'custom',
          }}
          loopAdditionalSlides={1}
          loopAddBlankSlides
          initialSlide={activeIndex}
          spaceBetween={0}
          onActiveIndexChange={onActiveIndexChange}
          centeredSlides
          loop={slides.length > 1}
          slideToClickedSlide
          direction="horizontal"
          navigation={{
            nextEl: '.cgt-carousel-new__navigation-button--next',
            prevEl: '.cgt-carousel-new__navigation-button--prev',
          }}
          keyboard={{
            enabled: true,
            onlyInViewport: true,
          }}
        >
          {!!slides.length
            && slides.map((slide, index) => (
              <SwiperSlide key={`cgt-slide-${index}`}>
                {({ isActive }) => {
                  const temp = `cgt-carousel-new__image
                    ${isActive ? 'cgt-carousel-new__image--active' : ''}
                    ${highlightActive ? 'cgt-carousel-new__image--highlight' : ''}`

                  return (
                    <Fragment>
                      <img alt="" className={temp} src={slide} loading={index === 0 ? 'eager' : 'lazy'} />
                      <div className="cgt-carousel-new__image-loader cgt-spinner" />
                    </Fragment>
                  )
                }}
              </SwiperSlide>
            ))}
        </Swiper>
        {totalCount > 1 && (
          <Fragment>
            <NavigationButton
              icon="ArrowLeft"
              customClass="cgt-carousel-new__navigation-button--prev"
            />
            <NavigationButton
              icon="ArrowRight"
              customClass="cgt-carousel-new__navigation-button--next"
            />
          </Fragment>
        )}
      </Fragment>
    )
  }

  return <p>loading...</p>
}

Carousel.propTypes = {
  slides: array.isRequired,
  onActiveIndexChange: func.isRequired,
  highlightActive: bool,
  activeIndex: number.isRequired,
  totalCount: number.isRequired,
}

export default Carousel
